import React, { useContext } from "react";

import { DataContext } from "../../../../../../providers/ElectricityCheckoutDataProvider";
import Checkbox from "../../../../../shared/forms/Checkbox";
import * as styles from "./style.module.scss";

const ReceiveNewsletter = () => {
    const dataContext = useContext(DataContext);

    const { receiveNewsletter } = dataContext.data;
    const { setReceiveNewsletter } = dataContext.actions;

    return (
        <React.Fragment>
            <div className={styles.checkboxRow}>
                <div>
                    <Checkbox
                        className={styles.checkbox}
                        checked={receiveNewsletter}
                        onClick={() => {
                            setReceiveNewsletter(1 - receiveNewsletter);
                        }}
                    />
                </div>
                <div className={styles.checkboxLabel}>
                    <span>
                        {" "}
                        Ich stimme zu, dass die Hoyer Strom und Erdgas GmbH mir
                        per E-Mail Newsletter mit Informationen über neue
                        Produkte, Veranstaltungen und Angebote von der Hoyer
                        Unternehmensgruppe zusendet und mich in den
                        Newsletter-Verteilerkreis aufnimmt. Zum Zweck des
                        Versands beauftragt die Hoyer Strom und Erdgas GmbH
                        einen Dienstleister. Dort werden für die Dauer des
                        Versandes der elektronischen Informationen meine
                        E-Mail-Adresse und mein Name kurzfristig hochgeladen.
                    </span>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ReceiveNewsletter;
